import React, { useRef, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useIntl } from 'react-intl';

import { useSeo } from '~hooks/useSeo';
import { useLayout } from '~hooks/useLayout';
import { useLocationDetails } from '~hooks/useLocationDetails';

import NotFound from '~components/not-found';

import LocationSearchBar from './location-search-bar';
import LocationContext from './locationContext';
import Header from './header';
import CustomersList from './list';

import './style.scss';
import { getValidatedQueryString } from '~helpers/queryUtils';

const Customers = () => {
  const intl = useIntl();
  const urlLocation = useLocation();
  const [locationId, setLocationId] = useState(null);
  const initialSearchLocationId = useRef(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const { locationDetails, pricingDetails, isLoading, requestLocationByID, locationTouched, isLocationInvalid } =
    useLocationDetails(locationId, [urlLocation.pathname]);

  useEffect(() => {
    try {
      const queryParams = queryString.parse(getValidatedQueryString(urlLocation.search)) || null;
      const parsedLocationId = queryParams?.locationId || null;
      setLocationId(parsedLocationId);
      initialSearchLocationId.current = parsedLocationId;
    } catch (err) {
      setLocationId(null);
    } finally {
      setIsInitialLoad(false);
    }
  }, [urlLocation.search]);

  useEffect(() => {
    if (locationId && !locationDetails && !isLoading && !isLocationInvalid) {
      requestLocationByID(locationId);
    }
  }, [locationId, locationDetails, isLoading, isLocationInvalid]);

  useLayout({
    displayFooter: false,
  });

  useSeo(
    intl.formatMessage({
      id: 'containers.customers.seo.default.title',
    })
  );

  return (
    <LocationContext.Provider
      value={{
        locationDetails,
        pricingDetails,
        initialSearchLocationId: initialSearchLocationId.current,
        onChangeLocation: requestLocationByID,
        isLoadingLocation: isLoading,
        locationTouched,
      }}
    >
      <section className="c-page l-container c-page--matches">
        <Header />
        
        {!locationId ? (
          <>
            <div className="c-location-intro">
              {intl.formatMessage({
                id: 'containers.customers.intro',
                defaultMessage: 'Lets get started! Please write down your work address',
              })}
            </div>
            <LocationSearchBar />
          </>
        ) : isLocationInvalid ? (
          <NotFound
            headline={intl.formatMessage({
              id: 'containers.customers.location-not-found.headline',
              defaultMessage: 'Location not found',
            })}
            content={intl.formatMessage({
              id: 'containers.customers.location-not-found.content',
              defaultMessage: 'This address is no longer available. Please search for a different address.',
            })}
          />
        ) : !locationDetails && !isLoading ? (
          // <LocationSearchBar />
          null
        ) : (
          <CustomersList />
        )}
      </section>
    </LocationContext.Provider>
  );
};

export default Customers;
